import {
  AssetLogo,
  isSvgIconName,
  LogoTypes,
  SvgIconNames,
} from '@toggle/design-system';
import { StrictUnion } from '@toggle/helpers';
import { Entity, getAssetLogoFromEntity, MappedEntity } from '@toggle/toggle';
import clsx from 'clsx';
import React from 'react';

import { resolveImageUrl } from '~/utils/resolve-image-url/resolveImageUrl';

import { useThemeStore } from '../theme-controller/stores/useThemeStore';
import { isDarkTheme } from '../theme-controller/utils/theme-utils/theme-utils';
import styles from './AssetLogoContainer.module.scss';

export type AssetLogoContainerProps = {
  className?: string;
  isDarkTheme?: boolean;
  entity: StrictUnion<Entity | MappedEntity>;
  size?: number;
  withFallback?: boolean;
  shouldUseBorderOnFallback?: boolean;
};

export const AssetLogoContainer = ({
  className,
  shouldUseBorderOnFallback = false,
  ...props
}: AssetLogoContainerProps) => {
  const themeName = useThemeStore(state => state.themeName);
  const isDark = isDarkTheme(themeName);
  const {
    entity: mappedEntity,
    variant,
    isNotStockEntity,
    isFiEntity,
    iconName,
    subClassIcon,
  } = getAssetLogoFromEntity(props.entity);

  const safeIconName: SvgIconNames = isSvgIconName(iconName)
    ? iconName
    : 'ChartLine';
  const safeSubClassIcon: SvgIconNames = isSvgIconName(subClassIcon)
    ? subClassIcon
    : 'ChartLine';

  const type = variant ? LogoTypes[variant] : undefined;
  const logoUrl = resolveImageUrl(
    isDark ? mappedEntity.logo_urls.light_png : mappedEntity.logo_urls.dark_png
  );

  return (
    <div
      className={clsx(styles.wrapper, className, {
        [styles.shouldUseBorderOnFallback]: shouldUseBorderOnFallback,
      })}
    >
      <AssetLogo
        {...props}
        type={type}
        isNotStockEntity={isNotStockEntity}
        isFiEntity={isFiEntity}
        placeholderIconName={safeIconName}
        placeholderSubClassIcon={safeSubClassIcon}
        entity={mappedEntity}
        logoUrl={logoUrl}
      />
    </div>
  );
};
